import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { EventTypeService } from '../../../../../../services/event-type/event-type.service';

import { EventType} from '../../../../../../models/event-type';
import { AccountService } from '../../../../../../services/account/account.service';
import { CurrencyRefundAmount } from '../../../../../../models/event-type-enums';

@Component({
  selector: 'app-event-type-cancellation-policy',
  templateUrl: './event-type-cancellation-policy.component.html',
  styleUrls: ['./event-type-cancellation-policy.component.css']
})
export class EventTypeCancellationPolicyComponent implements OnInit {

  readonly SUBMIT_TYPE_GO_BACK = 'goBack';
  readonly SUBMIT_TYPE_CONTINUE = 'continue';

  public eventType: EventType = null;
  public submitType = this.SUBMIT_TYPE_CONTINUE;

  public eventTypeErrorMessage = '';
  public eventTypeErrors: any = {};
  public eventTypeSuccessMessage = '';

  public loadingEventType = true;

  public eventTypeNotFound = false;
  public serverError: number = null;

  public readonly CurrencyRefundAmount = CurrencyRefundAmount;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private eventTypeService: EventTypeService
  ) {}

  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    const eventTypeIdInt = parseInt(routeParams.id, 10);
    if (isNaN(eventTypeIdInt)) {
      this.eventTypeNotFound = true;
      return;
    }

    this.loadEventType(eventTypeIdInt);
  }

  /**
   * Load the event type with the given ID.
   *
   * @param eventTypeId - The API ID of the event type.
   */
  public loadEventType(eventTypeId: number) {
    this.loadingEventType = true;

    this.eventTypeService
      .getEventType(eventTypeId)
      .then(eventType => {
        this.eventType = eventType;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else if (reason.status === 404) {
          this.eventTypeNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEventType = false; });
  }

  /**
   * Whether there are any outstanding API requests in progress.
   */
  public isLoading() {
    return this.loadingEventType;
  }

  /**
   * Handle an event type cancellation policy form submission.
   */
  public onCancellationPolicySubmit() {
    this.loadingEventType = true;

    this.eventTypeErrorMessage = '';
    this.eventTypeErrors = {};
    this.eventTypeSuccessMessage = '';

    this.eventTypeService
      .updateEventTypeCancellationPolicy(this.eventType)
      .then(updatedEventType => {
        this.eventType = updatedEventType;

        // Routing depends on which save button was clicked.
        if (this.submitType === this.SUBMIT_TYPE_GO_BACK) {
          this.router.navigate(
            [
              '/events/setup/event-types'
            ],
            {
              queryParams: {
                status: this.eventType.status
              },
              state: {
                feedback: {
                  text: 'Event \'' + this.eventType.name + '\' saved successfully.',
                  status: 'success'
                }
              }
            }
          );
        } else if (this.submitType === this.SUBMIT_TYPE_CONTINUE) {
          this.router.navigate(
            ['/events/setup/edit/' + this.eventType.id.toString() + '/waitlist']
          );
        }
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.eventTypeErrors = reason.error;
          this.eventTypeErrorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.eventTypeErrorMessage = 'You do not have permission to modify this event.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEventType = false; });
  }

}
